import * as VideoType from '../player/videoSource/videoTypes';
import * as ADBPVideoType from '../tracking/ADBPVideoType';

import { inIframe } from '../utils/ASVPUtils';

import attempt from 'lodash/attempt';


export default class ADBP {
    constructor () {
        if (!window.trackMetrics) return false;
    }

    static getVideoData (sourceData, additionalData = {}) {
        if (!sourceData) return {};

        const videoData = Object.assign({}, {
            id: sourceData.id,
            title: this.getOmnitureVideoTitle(sourceData),
            type: this.getOmnitureVideoType(sourceData.type),
            offsite: inIframe(true),
            player_ad: undefined,
            segment_id: 1,
        }, additionalData);

        return { video: videoData };
    }

    static getUserInteractionData(sourceData, interactionType = 'user-interaction') {
        if (!sourceData) return {};

        return {
            interaction: interactionType,
            title: this.getOmnitureVideoTitle(sourceData)
        };
    }

    static getOmnitureVideoType (type) {
        switch (type) {
            case VideoType.CLIP:
                return ADBPVideoType.CLIP;
            case VideoType.CLIPESODE:
                return ADBPVideoType.CLIPESODE;
            case VideoType.EPISODE:
                return ADBPVideoType.EPISODE;
            case VideoType.MARATHON:
                return ADBPVideoType.MARATHON;
            case VideoType.STREAM:
                return ADBPVideoType.STREAM;
            default:
                return ADBPVideoType.CLIP;
        }
    }

    static getOmnitureVideoTitle (videoData) {
        return (videoData.type === VideoType.STREAM) ? 'streams:' + videoData.title : videoData.collectionTitle + ':' + videoData.title;
    }

    static track (type, data) {
        if (!data) return;
        return attempt(() => window.trackMetrics({ type, data }));
    }

    static getClassName () {
        return 'analytics';
    }
};




// WEBPACK FOOTER //
// ./src/tracking/ADBP.js